import { render, staticRenderFns } from "./ClientAdminDashboard.vue?vue&type=template&id=3979824f&scoped=true&"
import script from "./ClientAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ClientAdminDashboard.vue?vue&type=style&index=0&id=3979824f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979824f",
  null
  
)

export default component.exports